import { render } from "./search.vue?vue&type=template&id=5fc4e1f6&scoped=true"
import script from "./search.vue?vue&type=script&lang=js"
export * from "./search.vue?vue&type=script&lang=js"

import "./search.vue?vue&type=style&index=0&id=5fc4e1f6&scoped=true&lang=css"
import "./search.vue?vue&type=style&index=1&id=5fc4e1f6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fc4e1f6"]])

export default __exports__